// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"394":"e5bf4b7a","398":"e396b64c","547":"b1a7a33a","562":"286d1c6d","634":"7f792869","698":"a80a9ef7","787":"2ce20ba6"}[chunkId] + ".chunk.js";
};